import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="nd-footer-wrapper">
            <div className="nd-footer-ambient-glow"></div>
            
            <div className="container position-relative">
                <div className="nd-footer-main">
                    <div className="row g-4">
                        {/* Brand & Contact Column */}
                        <div className="col-xl-4 col-lg-5 col-md-12">
                            <div className="nd-footer-brand-info">
                                <Link to="/" className="nd-footer-logo-link">
                                    <img
                                        src="../assets/images/icon/logo01.png"
                                        alt="ND Connect Logo"
                                        className="img-fluid nd-footer-logo"
                                    />
                                </Link>
                                <p className="nd-footer-desc">
                                    We make experience that are alluring, easy to utilize, and drive results for your organization. We are not your typical web development organization.
                                </p>

                                <div className="nd-contact-chips">
                                    <div className="nd-contact-item">
                                        <div className="nd-contact-icon">
                                            <i className="fas fa-map-marker-alt" />
                                        </div>
                                        <span>D-159, First Floor, Sector 7, Noida, Uttar Pradesh-201301</span>
                                    </div>
                                    <div className="nd-contact-item">
                                        <div className="nd-contact-icon">
                                            <i className="fas fa-phone-alt" />
                                        </div>
                                        <a href="tel:918826302378">+91 8826302378</a>
                                    </div>
                                    <div className="nd-contact-item">
                                        <div className="nd-contact-icon">
                                            <i className="fas fa-envelope" />
                                        </div>
                                        <a href="mailto:info@ndtechland.com">info@ndtechland.com</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Legal Links */}
                        <div className="col-xl-2 col-lg-2 col-md-4 col-6">
                            <div className="nd-footer-nav-block">
                                <h5 className="nd-footer-heading">Legal</h5>
                                <ul className="nd-footer-links-list">
                                    <li>
                                        <Link to="/Termsconditions">Terms of Services</Link>
                                    </li>
                                    <li>
                                        <Link to="/Privacypolicy">Privacy Policy</Link>
                                    </li>
                                    <li>
                                        <Link to="/Cookiepolicy">Cookie Policy</Link>
                                    </li>
                                    <li>
                                        <Link to="/Datasecurity">Data Security</Link>
                                    </li>
                                    <li>
                                        <Link to="/Refunpolicy">Refund Policy</Link>
                                    </li>
                                    <li>
                                        <Link to="/Datasafety">Data Safety and Web Security</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Support Links */}
                        <div className="col-xl-2 col-lg-2 col-md-4 col-6">
                            <div className="nd-footer-nav-block">
                                <h5 className="nd-footer-heading">Support</h5>
                                <ul className="nd-footer-links-list">
                                    <li>
                                        <Link to="/Helpcenter">Help Center</Link>
                                    </li>
                                    <li>
                                        <Link to="/Faq">FAQs</Link>
                                    </li>
                                    <li>
                                        <Link to="/Customersupport">Customer Support</Link>
                                    </li>
                                    <li>
                                        <Link to="/Userguide">User Guides</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Other Services */}
                        <div className="col-xl-2 col-lg-3 col-md-4 col-6">
                            <div className="nd-footer-nav-block">
                                <h5 className="nd-footer-heading">Other Services</h5>
                                <ul className="nd-footer-links-list">
                                    <li>
                                        <Link to="/Chartedfirmservices">Chartered Firm Services</Link>
                                    </li>
                                    <li>
                                        <Link to="/Lawfirmservices">Law Firm Services</Link>
                                    </li>
                                    <li>
                                        <Link to="/Digitalmarketing">Digital Marketing Services</Link>
                                    </li>
                                    <li>
                                        <Link to="/Publicrelation">PR & Marketing Services</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Follow Us / Social Links */}
                        <div className="col-xl-2 col-lg-12 col-md-12 col-6">
                            <div className="nd-footer-nav-block">
                                <h5 className="nd-footer-heading">Follow Us</h5>
                                <div className="nd-social-buttons-wrap">
                                    <a 
                                        href="https://in.linkedin.com/company/nd-techland" 
                                        target="_blank" 
                                        rel="noreferrer"
                                        className="nd-social-btn nd-social-linkedin"
                                    >
                                        <i className="fab fa-linkedin-in"></i>
                                        <span>LinkedIn</span>
                                    </a>
                                    <a 
                                        href="https://www.facebook.com/ndtechland/" 
                                        target="_blank" 
                                        rel="noreferrer"
                                        className="nd-social-btn nd-social-facebook"
                                    >
                                        <i className="fab fa-facebook-f"></i>
                                        <span>Facebook</span>
                                    </a>
                                    <a 
                                        href="https://www.instagram.com/ndtechland/" 
                                        target="_blank" 
                                        rel="noreferrer"
                                        className="nd-social-btn nd-social-instagram"
                                    >
                                        <i className="fab fa-instagram"></i>
                                        <span>Instagram</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Subfooter */}
                <div className="nd-sub-footer">
                    <div className="row align-items-center">
                        <div className="col-md-12 text-center">
                            <p className="nd-copyright-text">
                                Copyright 2024-2025 by <span className="nd-copyright-brand"><i className="fas fa-heart text-danger me-1" /> N D Techland Pvt Ltd</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
